import { useState, useEffect } from 'react'
import { Input, Modal, Button } from 'Common/Supplyvue-ui'
import { Box, CircularProgress, Typography } from '@mui/material'
import { OperationalPlannerRenameModalPropsType } from './OperationalPlanner.types'

export const OperationalPlannerRenameModal = ({
  planName = '',
  isModalOpen = false,
  handleModalClose,
  handleRenameClick,
  isLoading,
  nameList,
}: OperationalPlannerRenameModalPropsType) => {
  const [newPlannerName, setNewPlannerName] = useState('')
  const [isNameAlreadyTaken, setIsNameAlreadyTaken] = useState(false)

  useEffect(() => {
    setNewPlannerName(planName)
  }, [planName])

  useEffect(() => {
    const found = nameList.find((name: string) => name === newPlannerName)
    if (found) {
      setIsNameAlreadyTaken(true)
    } else {
      setIsNameAlreadyTaken(false)
    }
  }, [newPlannerName, nameList])

  const handlePlanNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewPlannerName(event.target.value)
  }

  const Body = (
    <Box width="480px">
      <Box marginBottom="5px">
        <Typography variant="h4">New plan name</Typography>
      </Box>

      <Input
        fullWidth
        value={newPlannerName}
        onChange={handlePlanNameChange}
        ariaLabel="Rename plan"
      />
      <Box marginTop={3} color="red">
        {isNameAlreadyTaken && (
          <Typography variant="h4">
            This name is already taken, please try a new name.
          </Typography>
        )}
      </Box>
    </Box>
  )
  const Footer = (
    <Box>
      <Button
        variant="outlined"
        onClick={handleModalClose}
        sx={{
          marginLeft: '20px',
          minWidth: '105px',
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={
          newPlannerName === '' ||
          newPlannerName === planName ||
          isNameAlreadyTaken
        }
        onClick={() => handleRenameClick(newPlannerName)}
        sx={{
          marginLeft: '20px',
          minWidth: '105px',
        }}
      >
        {isLoading && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{
              marginRight: '8px',
            }}
          />
        )}
        Rename
      </Button>
    </Box>
  )
  return (
    <Modal
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return
        }
        // Handle other close events
        handleModalClose()
      }}
      aria-labelledby="Rename plan"
      open={isModalOpen}
      handleClose={handleModalClose}
      header="Rename plan"
      body={Body}
      footer={Footer}
    />
  )
}
